<template>
  <div id="app" class="yolcum-nerede-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat class="page-card">
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar dark color="info" class="page-toolbar">
              <v-toolbar-title>{{ 'Yolcum Nerede' }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list>
                  <v-list-tile @click="getListExcel()" v-if="PB == 'TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid v-if="raportipi == 'Bilet'" class="page-container">
            <v-layout row wrap>
              <v-flex pb-3 xs12 sm12 md12>
                <v-card flat class="filter-card">
                  <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp
                          :etiket="$t('Date')"
                          :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.VarisTarih1"
                          v-model="Rapor.VarisTarih1"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp
                          :etiket="$t('Date')"
                          :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.VarisTarih2"
                          v-model="Rapor.VarisTarih2"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <parkurcomp v-model="Rapor.VarisParkur"></parkurcomp>
                      </v-flex>

                      <v-flex xs12 sm6 md2 pt-2>
                        <cariaracomp
                          v-bind:etiket="$t('Currentcode_label')"
                          :loading="loading"
                          v-bind:value="Rapor.Musteri_Kodu"
                          v-model="Rapor.Musteri_Kodu"
                        ></cariaracomp>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout align-center>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>

                          <div v-if="progress">
                            <v-layout align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md12 pb-3>
                <ReportTable
                  :headers="headersBilet"
                  :items="itemssatis"
                  :loading="progress"
                  :has-searched="hasSearchedBilet"
                  :storage-key="'yolcumnerede_bilet_report_table'"
                  :search-label="$t('Search')"
                  :show-frontend-export="true"
                  :rows-per-page-items="[20, 50, 100, 200]"
                  class="report-table-host"
                >
                  <template slot="cell" slot-scope="slotProps">
                    {{ slotProps.value }}
                  </template>
                </ReportTable>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid v-if="raportipi == 'Otel'" class="page-container">
            <v-layout row wrap>
              <v-flex pb-3 xs12 sm12 md12>
                <v-card flat class="filter-card">
                  <v-form ref="formgunluksatisotel" v-model="valid" lazy-validation>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp
                          :etiket="$t('Date')"
                          :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="RaporOtel.Tarih1"
                          v-model="RaporOtel.Tarih1"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp
                          :etiket="$t('Date')"
                          :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="RaporOtel.Tarih2"
                          v-model="RaporOtel.Tarih2"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 md2 pt-2>
                        <cariaracomp
                          :Coper="true"
                          v-bind:etiket="$t('Currentcode_label')"
                          :loading="loading"
                          v-bind:value="RaporOtel.Cari_Kod"
                          v-model="RaporOtel.Cari_Kod"
                        ></cariaracomp>
                      </v-flex>

                      <v-flex xs12 sm6 md2 pt-2>
                        <pnrbul v-model="RaporOtel.PNR_No" hide-details></pnrbul>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout align-center>
                          <div v-if="load1">
                            <v-btn color="info" @click="getListOtel()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>

                          <div v-if="progress">
                            <v-layout align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>

                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                            </template>

                            <v-btn
                              small
                              @mouseenter="tooltip = true"
                              @mouseleave="tooltip = false"
                              ref="fab"
                              @click="filtrele()"
                              color="info"
                              fab
                              dark
                            >
                              <v-icon>filter_list</v-icon>
                            </v-btn>

                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{ $t('Add-Search-Filter') }}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md12 pb-3>
                <ReportTable
                  :headers="headersOtel"
                  :items="itemssatisotel"
                  :loading="progress"
                  :has-searched="hasSearchedOtel"
                  :storage-key="'yolcumnerede_otel_report_table'"
                  :search-label="$t('Search')"
                  :show-frontend-export="true"
                  :rows-per-page-items="[20, 50, 100, 200]"
                  class="report-table-host"
                >
                  <template slot="cell" slot-scope="slotProps">
                    <template v-if="slotProps.column.value === 'PNR_No'">
                      <a
                        href="#"
                        @click.prevent.stop="pnrGit(slotProps.item.PNR_No)"
                        class="pnr-link"
                      >
                        {{ slotProps.item.PNR_No }}
                      </a>
                    </template>
                    <template v-else>
                      {{ slotProps.value }}
                    </template>
                  </template>
                </ReportTable>
              </v-flex>
            </v-layout>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{ $t('Close') }}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="350px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat>
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <genelarama
                                :autofocuss="true"
                                apiname="SaticiAra"
                                :tip="1"
                                :label="$t('Seller-Code')"
                                v-model="RaporOtel.SaticiAdi"
                              ></genelarama>
                            </v-flex>

                            <v-autocomplete
                              :items="ulkeTipi"
                              hide-details
                              :no-data-text="$t('No-Records-Found')"
                              v-model="RaporOtel.SaticiUlke"
                              item-text="Isim"
                              item-value="Isim"
                              clearable
                              :label="$t('Country_label')"
                              @change="getCity(RaporOtel.SaticiUlke)"
                            >
                            </v-autocomplete>

                            <v-autocomplete
                              @change="getDistinct(RaporOtel.SaticiSehir)"
                              :items="sehirTipi"
                              hide-details
                              v-model="RaporOtel.SaticiSehir"
                              :no-data-text="$t('No-Records-Found')"
                              item-text="Isim"
                              item-value="Isim"
                              clearable
                              :label="$t('City')"
                            >
                            </v-autocomplete>

                            <v-autocomplete
                              :no-data-text="$t('No-Records-Found')"
                              :items="ilceTipi"
                              hide-details
                              v-model="RaporOtel.SaticiYer"
                              item-text="Isim"
                              item-value="Isim"
                              :label="$t('District')"
                            >
                            </v-autocomplete>

                            <v-flex xs12 sm12 md12>
                              <v-layout justify-space-between column>
                                <v-checkbox
                                  v-model="RaporOtel.tumsirketler"
                                  :label="$t('All-Companies')"
                                  hide-details
                                ></v-checkbox>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{ $t("cancel_button") }}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import havayollaritumlistecomp from "@/components/app/customcomp/havayollaritumlistecomp.vue";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import parkurcomp from "@/components/app/bilet/partpage/parkurcomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";

function beforeMount() {}

function createBiletHeaders() {
  return [
    { text: "Kalkış", value: "Parkur", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Varış", value: "VarisParkur", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Uçuş Tarihi", value: "UcusTar", type: "date", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Uçuş Saat", value: "UcusSaat", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
    { text: "Varış Tarihi", value: "VarisTar", type: "date", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Varış Saat", value: "VarisSaat", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
    { text: "Yolcu Adı", value: "YolcuAdi", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
    { text: "Tel.", value: "bilettel", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "E-Mail", value: "email", type: "text", align: "left", visible: true, sortable: true, minWidth: "190px" },
    { text: "Müşteri", value: "Musteri_Kodu", type: "text", align: "left", visible: true, sortable: true, minWidth: "160px" },
    { text: "Bilet_No", value: "Bilet_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" }
  ];
}

function createOtelHeaders() {
  return [
    { text: "Müşteri", value: "Cari_Kod", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: "PNR_No", value: "PNR_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Ad", value: "Ad", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
    { text: "GSM", value: "GSM", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Telefon1", value: "Telefon1", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
    { text: "Email", value: "Email", type: "text", align: "left", visible: true, sortable: true, minWidth: "190px" },
    { text: "Satıcı", value: "SaticiAdi", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
    { text: "Satıcı Ülke", value: "SaticiUlke", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: "Satıcı Şehir", value: "SaticiSehir", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: "Satıcı Yer", value: "SaticiYer", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: "Başlangıç Tarih", value: "Donem1", type: "date", align: "left", visible: true, sortable: true, minWidth: "150px" },
    { text: "Bitiş Tarih", value: "Donem2", type: "date", align: "left", visible: true, sortable: true, minWidth: "150px" }
  ];
}

export default {
  data() {
    return {
      ulkeTipi: [],
      sehirTipi: [],
      ilceTipi: [],
      semtTipi: [],
      rules: {
        required: v => !!v || "Zorunlu alan",
        email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Geçerli bir e-posta girin"
      },
      PB: "TRY",
      raportipi: "Otel",
      raportipleri: ["Bilet", "Otel"],
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },
      filtrevarmi: false,
      kayitvarmi: false,
      search: "",
      searchsatilanbilet: null,
      headersBilet: [],
      headersOtel: [],
      Rapor: {
        VarisParkur: null,
        VarisTarih1: "",
        VarisTarih2: "",
        Musteri_Kodu: null
      },
      RaporOtel: {
        Cari_Kod: null,
        PNR_No: null,
        SaticiAdi: null,
        SaticiUlke: null,
        SaticiSehir: null,
        SaticiYer: null,
        Tarih1: "",
        Tarih2: "",
        tumsirketler: false,
        sayfaAdi: null
      },
      valid: true,
      tumsirketler: "",
      loadingana: false,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",
      renk1: "info",
      dialogfiltre: false,
      hesapkodu: [],
      statecari: [],
      searchcari: "",
      statecariana: [],
      searchcariana: "",
      progress: false,
      tooltip: false,
      el: null,
      yok: false,
      itemssatis: [],
      itemssatisotel: [],
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      hasSearchedBilet: false,
      hasSearchedOtel: false,
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t("Please-select-a-date")
          },
          tarihsec1: {
            required: () => this.$t("Please-select-a-date")
          }
        }
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  mounted() {
    this.headersBilet = createBiletHeaders();
    this.headersOtel = createOtelHeaders();

    this.$validator.localize("en", this.dictionary);

    if (this.$refs.fab && this.$refs.fab.$el) {
      this.el = this.$refs.fab.$el;
    }

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    tool.http_post(this, "UlkeList", {}).then(
      response => {
        if (response.body.Status == true) {
          this.ulkeTipi = response.body.data;
        } else {
          this.text1 = "Service Unavailable";
          this.snackbar = true;
        }
      },
      () => {
        this.text1 = "Service Unavailable";
        this.snackbar = true;
      }
    );
  },
  filters: {
    dateformat: function(t) {
      return helpers.dateformat(t);
    },
    moneyformat: function(m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function(m) {
      return helpers.bakiyekontrol(m);
    }
  },
  components: {
    tarihcomp: tarihcomp,
    referansmerkezicomp,
    yuzdeinput,
    havayollaritumlistecomp,
    masrafmerkezicomp,
    yetkidialog,
    parkurcomp,
    cariaracomp,
    pnrbul,
    genelarama,
    ReportTable
  },
  watch: {},
  methods: {
    onCellClick(item) {
      if (!item) {
        return;
      }
    },
    getCity(value) {
      if (value != null && value !== "undefined") {
        var ulkeId = 0;

        if (value !== value) {
          ulkeId = null;
          this.ulkeTipi.forEach(element => {
            if (element.Isim === this.RaporOtel.SaticiUlke) {
              ulkeId = element.Id;
            }
          });
        } else {
          this.ulkeTipi.forEach(element => {
            if (element.Isim === value) {
              ulkeId = element.Id;
            }
          });
        }

        var params = {
          UlkeId: ulkeId
        };

        tool.http_post(this, "IlList", params).then(
          response => {
            if (response.body.Status == true) {
              this.sehirTipi = response.body.data;
              if (this.RaporOtel.SaticiSehir != null) {
                this.getDistinct(this.RaporOtel.SaticiSehir);
              }
            }
          },
          () => {
            this.text1 = "Service Unavailable-IlList";
            this.snackbar = true;
          }
        );
      }
    },
    getDistinct(value) {
      if (value != null) {
        var SehirId = 0;
        if (value !== value) {
          SehirId = null;
          this.sehirTipi.forEach(element => {
            if (element.Isim === this.RaporOtel.SaticiSehir) {
              SehirId = element.Id;
            }
          });
        } else {
          this.sehirTipi.forEach(element => {
            if (element.Isim === value) {
              SehirId = element.Id;
            }
          });
        }
        var params = {
          IlId: SehirId
        };

        tool.http_post(this, "IlceList", params).then(
          response => {
            if (response.body.Status == true) {
              this.ilceTipi = response.body.data;
            }
          },
          () => {
            this.text1 = "Service Unavailable-IlList";
            this.snackbar = true;
          }
        );
      }
    },
    pnrGit(val) {
      let url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val;
      window.open(url, "_target");
    },
    getList: getList,
    getListOtel: getListOtel,
    getListHtml: getListHtml,
    getListExcel: getListExcel,
    filtrele: filtrele,
    filtrekayit: filtrekayit,
    filtreiptal: filtreiptal,
    tarihformat
  }
};

function tarihformat(t) {
  if (t != null) {
    var a = t.split("/");
    var tarih1 = a[0].replace("00:00:00", "") + " " + a[1].replace("00:00:00", "");
    return tarih1;
  } else {
    return null;
  }
}

function filtrele() {
  this.dialogfiltre = true;

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  var params = {
    CompanyCode: credentials.SirketKodu
  };

  this.$http.post(auth.API_URL + "api/TicketDefinitons/AirlineList", params, {
    headers: {
      Authorization: "Bearer " + auth.getAuthHeader()
    }
  }).then(response => {
    this.itemsairlinelist = response.body;
  }, () => {
    this.text1 = "Service Unavailable";
    this.progress = false;
    this.snackbar = true;
  });

  this.$http.post(auth.API_URL + "api/Definitions/CurrentGroupList", params, {
    headers: {
      Authorization: "Bearer " + auth.getAuthHeader()
    }
  }).then(response => {
    this.hesapgrubu = response.body;
  }, () => {
    this.text1 = "Service Unavailable";
    this.snackbar = true;
  });

  this.$http.post(auth.API_URL + "api/currency/List", params, {
    headers: {
      Authorization: "Bearer " + auth.getAuthHeader()
    }
  }).then(response => {
    this.doviztipi = response.body;
  }, () => {
    this.text1 = "Service Unavailable-Döviz";
    this.snackbar = true;
  });

  this.$http.post(auth.API_URL + "api/ExpenseCenter/List", params, {
    headers: {
      Authorization: "Bearer " + auth.getAuthHeader()
    }
  }).then(response => {
    this.masrafmerkezi = response.body;
  }, () => {
    this.text1 = "Service Unavailable-ExpenseCenter";
    this.snackbar = true;
  });
}

function filtrekayit() {
  this.filtrevarmi = true;
  this.dialogfiltre = false;
  this.getListOtel();
}

function filtreiptal() {
  this.filtrevarmi = false;
  this.dialogfiltre = false;
}

function getListOtel() {
  if (this.RaporOtel.SaticiAdi) {
    this.RaporOtel.SaticiAdi = this.RaporOtel.SaticiAdi.isim;
  }

  this.hasSearchedOtel = true;
  this.progress = true;
  this.load1 = false;

  tool.http_post(this, "OtelIsimListesi", this.RaporOtel).then(
    response => {
      if (response.body.Status == true) {
        this.itemssatisotel = response.body.data;
      } else {
        this.itemssatisotel = [];
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
      this.progress = false;
      this.load1 = true;
    },
    () => {
      this.itemssatisotel = [];
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
      this.progress = false;
      this.load1 = true;
    }
  );
}

function getList() {
  this.hasSearchedBilet = true;
  this.progress = true;
  this.load1 = false;

  tool.api_post(this, "TicketReport/UcusVarisListReport", this.Rapor).then(
    response => {
      if (response.body.Status == true) {
        this.itemssatis = response.body.data;
      } else {
        this.itemssatis = [];
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
      this.progress = false;
      this.load1 = true;
    },
    () => {
      this.itemssatis = [];
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
      this.progress = false;
      this.load1 = true;
    }
  );
}

function getListHtml() {}

function getListExcel() {
  var params = this.RaporOtel;

  tool.api_post_FileDownload(this, "Coper/ExcelOtelIsimListesi", params).then(
    response => {
      tool.CreateDownloadLink(response, "YolcumNerede.xlsx");
      this.progress = false;
      this.load1 = true;
    },
    () => {
      this.text1 = "Satış Listesi Getirilemedi";
      this.snackbar = true;
      this.progress = false;
      this.load1 = true;
    }
  );
}
</script>

<style scoped>
.yolcum-nerede-page {
  min-height: 100vh;
  background: #f1f3f5;
}

.page-card {
  min-height: 100vh;
}

.page-toolbar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.page-container {
  padding-top: 22px;
}

.filter-card {
  background: #ffffff;
  border-radius: 4px;
}

.report-table-host {
  width: 100%;
}

.cell-click-area {
  display: block;
  width: 100%;
  min-height: 24px;
}

.pnr-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}

@media (max-width: 960px) {
  .page-container {
    padding-top: 16px;
  }
}
</style>